/* eslint-disable react/style-prop-object */
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import '@styles/views/support.less';
import '@styles/components/appBannerNew.less';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppBannerNew = () => {
  const dispatch = useAppDispatch();
  const serviceList = [
    {
      name: '设计大师',
      detailed: 'CivilStation Designer',
      logo: require('@images/support/csdBan.png').default,
      logoimg: require('@images/common/CSD.png').default,
      engname: '设计大师',
      desc: '正向BIM设计软件',
      href: 'civilstationdesigner',
    },
    {
      name: '看模王',
      detailed: 'BIM Windows',
      logo: require('@images/support/BIMWin.png').default,
      logoimg: require('@images/support/BIMWindows.png').default,
      engname: '看模王',
      desc: '多功能BIM模型查看展示与处理软件',
      href: 'digitaltwin',
    },
    {
      name: '桥梁大师',
      detailed: '2023',
      logo: require('@images/support/qldsTheme.png').default,
      logoimg: require('@images/common/qlds.png').default,
      engname: '桥梁大师',
      desc: '二维CAD桥梁设计出图软件',
      href: 'introduce',
    },
    {
      name: '建造大师',
      detailed: 'CivilStation Construction',
      logo: require('@images/support/cscTheme.png').default,
      logoimg: require('@images/common/CSC.png').default,
      engname: '建造大师',
      desc: 'BIM施工综合管理平台',
      href: 'civilstationconstru',
    },
    {
      name: '跨界云空间',
      detailed: '跨越现实，无以为界',
      logo: require('@images/ksjspace/topimg.png').default,
      logoimg: require('@images/ksjspace/kj-logo.png').default,
      engname: '跨界云空间',
      desc: '跨越现实，无以为界',
      href: 'ksjspace',
    },
  ];

  const swiperSliderListJSX = serviceList.map((item) => {
    return (
      <SwiperSlide key={item.name}>
        <div className={'logoimg'}>
          <img src={item.logoimg} alt="" />
        </div>
        <div className={'title'}>
          <div className={'engname'} dangerouslySetInnerHTML={{ __html: item.engname }}></div>
        </div>
        <div className={'desc'} dangerouslySetInnerHTML={{ __html: item.desc }}></div>
        <div className={'swiper-item'}>
          <div className={'theme'}>
            <a className={'href'} href={'/bim-windows-h5/build/#/' + item.href}>
              <img src={item.logo} alt="" />
              <div className={'name'} dangerouslySetInnerHTML={{ __html: item.name }} />
              <div className={'detailed'} dangerouslySetInnerHTML={{ __html: item.detailed }}></div>
            </a>
          </div>
        </div>
      </SwiperSlide>
    );
  });
  return (
    <div className={'app-banner'}>
      <img className={'banner-bg'} src={require('@images/common/bannerBg.png').default} alt="" />
      <div className={'contentN'}>
        <div className={'business-desc'}>
          <Swiper slidesPerView={1.33} initialSlide={1} centeredSlides>
            {swiperSliderListJSX}
          </Swiper>
        </div>
        {/*  <div className={'theme'}>
          <img src={require('@images/common/BIMWindows.png').default} alt="" />
          <span>BIM 视窗</span>
          <p>BIM Windows</p>
        </div> */}
        <div className={'operate'}>
          <span className={'free-bim'} onClick={() => dispatch(setTryOutDialog(true))}>
            申请试用
          </span>
        </div>
      </div>
    </div>
  );
};

export default AppBannerNew;
